import Icon from "components/Icon";
import React, { useState , useEffect} from 'react';
import media from "assets/images/women.jpeg";
import formatTime from "utils/formatTime";
import AudioPlayer from "utils/AudioPlayer";
import ReactAudioPlayer from 'react-audio-player';
import ReactPlayer from 'react-player';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined';

function splitTextToLines(text) {
	let lines = [];
	let line = '';
  
	// Split the text into words
	let words = text.split(' ');
  
	for (let i = 0; i < words.length; i++) {
	  // If adding the next word would exceed the 25 character limit, start a new line
	  if (line.length + words[i].length > 25) {
		lines.push(line.trim());
		line = '';
	  }
  
	  // Add the word to the current line
	  line += words[i] + ' ';
	}
  
	// Add any remaining text as the last line
	if (line.length > 0) {
	  lines.push(line.trim());
	}
  
	// Join the lines into a single string with new line characters
	return lines.join('\n');
  }


const Convo = ({ lastMsgRef, messages: allMessages }) => {

	const [selectedFile, setSelectedFile] = useState(null);
	// console.log('CONVO All Messages', allMessages)
	const dates = Object.keys(allMessages);


	const handleClose = () => {
        setSelectedFile(null);
    };

	// const FileRenderer = ({ file, mime, message, formatTime, assignRef }) => {
	// 	if (mime.startsWith('image/')) {
	// 	  return <img src={file} alt="" className="chat__img" />;
	// 	} else if (mime.startsWith('audio/')) {
	// 	  return <ReactAudioPlayer src={file} controls />;
	// 	} else if (mime.startsWith('video/')) {
	// 	  return <ReactPlayer url={file} controls width="100%" height="auto" />;
	// 	} else {
	// 	  return (
	// 		<a href={file} target="_blank" rel="noopener noreferrer">
	// 		  Download document
	// 		</a>
	// 	  );
	// 	}
	//   };

	const extractFileNameFromUrl = (fileUrl) => {
		let url = new URL(fileUrl);
		let pathName = url.pathname;
		let fileName = pathName.substring(pathName.lastIndexOf('/') + 1);
		return fileName;

	}

// function parseTextWithURLs(text) {
//     const urlRegex = /(https?:\/\/[^\s]+)/g;
//     const splits = text.split(urlRegex);

//     const fragments = splits.map((fragment, i) =>
//         i % 2 === 0
//             ? fragment
//             : <a key={i} href={fragment} target="_blank" rel="noopener noreferrer">Click here</a>
//     );

//     // Filter out the URLs to append them later
//     const texts = fragments.filter((item, index) => index % 2 === 0);
//     const urls = fragments.filter((item, index) => index % 2 !== 0);

//     return (
//         <>
//             {texts}
//             {urls.length > 0 && <br />}
//             {urls}
//         </>
//     );
// }

	function parseTextWithURLs(text) {
    if (text === null) {
        return null;
    }

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const splits = text.split(urlRegex);

    if (splits.length === 1) {
        return text; // Return the original text if no URLs found
    }

    const fragments = splits.map((fragment, i) =>
        i % 2 === 0 || !fragment
            ? fragment
            : <a key={i} href={fragment} target="_blank" rel="noopener noreferrer">Click here</a>
    );

    // Filter out the URLs to append them later
    const texts = fragments.filter((item, index) => index % 2 === 0);
    const urls = fragments.filter((item, index) => index % 2 !== 0 && item);

    return (
        <>
            {texts}
            {urls.length > 0 && <br />}
            {urls}
        </>
    );
}

	function ParseTextComponent({ text }) {
		const urlRegex = /(https?:\/\/[^\s]+)/g;
		const splits = text.split(urlRegex);

		const shouldAddIcon = text.startsWith("USER_RESPONSE_") || text.startsWith("BOT_RESPONSE_");

		const fragments = splits.map((fragment, i) =>
			i % 2 === 0
				? fragment
				: <a key={i} href={fragment} target="_blank" rel="noopener noreferrer">Click here</a>
		);

		// Filter out the URLs to append them later
		const texts = fragments.filter((item, index) => index % 2 === 0);
		const urls = fragments.filter((item, index) => index % 2 !== 0);

		// New Button content
		const [showText, setShowText] = useState(false);
		const toggleTextVisibility = () => setShowText(!showText);

		const renderTextWithButton = (content) => {
			return (
				<>
					{shouldAddIcon && <SmartToyOutlined />}
					<Button onClick={toggleTextVisibility}>
						{showText ? content : "הצג הודעת בוט"}
					</Button>
				</>
			);
		};

		return (
			<>
				{texts.map((t, idx) => (
					<span key={idx}>
						{shouldAddIcon ? renderTextWithButton(t) : t}
					</span>
				))}
				{urls.length > 0 && <br />}
				{urls}
			</>
		);
	}


	const FileRenderer = ({ file, mime, message, formatTime, assignRef }) => {
		if (mime.startsWith('image/')) {
		  return <img src={file} alt="" style={{ width: "200px" }} onClick={() => setSelectedFile([file,mime, extractFileNameFromUrl(file)])}/>
		} else if (mime.startsWith('audio/')) {
		  return <ReactAudioPlayer src={file} controls />;
		} else if (mime.startsWith('video/')) {
			console.log('Video file is: ', file)
			return <video controls src={file} style={{ width: "200px" }} onClick={() => setSelectedFile([file,mime, extractFileNameFromUrl(file)])}/>
		//return <ReactPlayer url={file} controls width="100%" height="auto" />;
		} else {
		  return <DescriptionIcon onClick={() => setSelectedFile([file,mime, extractFileNameFromUrl(file)])} style={{ cursor: 'pointer' }}/>
		}
	  };


	const messageStatus = (value) => {
		switch(value) {
		  case 'sent':
			return 'singleTick';
		case 'delivered':
			return 'doubleTick';
		case 'read':
			return 'doubleTick';
		  default:
			return 'undelivered';
		}
	  }


	  function BoldText({ text }) {
		const boldText = text
		  .split('\n')
		  .map((line, index) => (
			<div key={index}>
			  {line.replace(/\*(.*?)\*/g, '<strong>$1</strong>')}
			</div>
		  ));
		return <>{boldText}</>;
	  }

	  function getDirection(text) {
		const hebrewChar = /[\u0590-\u05FF]/;
		return hebrewChar.test(text) ? 'rtl' : 'ltr';
	  }
	return dates.map((date, dateIndex) => {
		const messages = allMessages[date];
		return (
			<div key={dateIndex}>
				<div className="chat__date-wrapper">
					<span className="chat__date"> {date}</span>
				</div>
				{dateIndex === 0 && (
					<p className="chat__encryption-msg">
						<Icon id="lock" className="chat__encryption-icon" />
						Messages are end-to-end encrypted. No one outside of this chat, not even WhatsApp, can read or listen to them. Click to learn more.
					</p>
				)}
				<div className="chat__msg-group">
					{messages.map((message, msgIndex) => {
						const assignRef = () =>
							dateIndex === dates.length - 1 && msgIndex === messages.length - 1
								? lastMsgRef
								: undefined;
		
						const textDirection = getDirection(message?.body);
		
						return (
							<>
								{message.file ? (
									<div
										className={`chat__msg chat__file-wrapper ${message.direction === 1 ? 'chat__msg--sent' : 'chat__msg--rxd'}`}
										ref={assignRef()}
										style={{ direction: textDirection }}
									>
										<FileRenderer
											file={message.file}
											mime={message.mime}
											message={message}
											formatTime={formatTime}
											assignRef={assignRef}
										/>
										<span className="chat__msg-footer">
											<span>{formatTime(message.createdAt)}</span>
											{message.direction === 1 && (
												<Icon
													id={messageStatus(message.status)}
													aria-label={message.status}
													className={`chat__msg-status-icon ${message.status === 'read' ? 'chat__msg-status-icon--blue' : ''}`}
												/>
											)}
										</span>
										<button aria-label="Message options" className="chat__msg-options">
											<Icon id="downArrow" className="chat__msg-options-icon" />
										</button>
									</div>
								) : message.direction === 0 ? (
									<p className="chat__msg chat__msg--rxd" ref={assignRef()} style={{ direction: textDirection }}>
										{message.body && (
											<span>
												<ParseTextComponent text={message?.body} />
											</span>
										)}
										<span className="chat__msg-filler"> </span>
										<span className="chat__msg-footer">
											{formatTime(message.createdAt)}
										</span>
										<button aria-label="Message options" className="chat__msg-options">
											<Icon id="downArrow" className="chat__msg-options-icon" />
										</button>
									</p>
								) : (
									<p className="chat__msg chat__msg--sent" ref={assignRef()} style={{ direction: textDirection }}>
										{message.body && (
											<span>
												<ParseTextComponent text={message?.body} />
											</span>
										)}
										<span className="chat__msg-filler"> </span>
										<span className="chat__msg-footer">
											<span> {formatTime(message.createdAt)} </span>
											{message.direction === 1 && (
												<Icon
													id={messageStatus(message.status)}
													aria-label={message?.status}
													className={`chat__msg-status-icon ${message?.status === "read" ? "chat__msg-status-icon--blue" : ""}`}
												/>
											)}
										</span>
										<button aria-label="Message options" className="chat__msg-options">
											<Icon id="downArrow" className="chat__msg-options-icon" />
										</button>
									</p>
								)}
							</>
						);
					})}
				</div>
				<Dialog open={selectedFile !== null} onClose={handleClose}>
					<DialogContent>
						{selectedFile && selectedFile[1].startsWith('image/') && (
							<img src={selectedFile[0]} alt={selectedFile[2]} style={{ width: '100%' }} />
						)}
						{selectedFile && selectedFile[1].startsWith('video/') && (
							<video controls src={selectedFile[0]} style={{ width: '100%' }} />
						)}
						{selectedFile && !selectedFile[1].startsWith('image/') && !selectedFile[1].startsWith('video/') && (
							<p>file: selectedFile[2]</p>
						)}
					</DialogContent>
					{selectedFile !== null && (
						<DialogActions>
							<IconButton onClick={handleClose}>
								<CloseIcon />
							</IconButton>
							<IconButton onClick={(event) => {
								event.preventDefault();
								window.open(selectedFile[0], 'popupWindow', 'height=600,width=800,left=10,top=10,,scrollbars=yes,menubar=no');
								window.open(selectedFile[0], '_blank');
							}}>
								<DownloadIcon />
							</IconButton>
						</DialogActions>
					)}
            	</Dialog>
			</div>
		);
	});
};

export default Convo;
